import React, { Component } from 'react';
import '../../../App.css';

import uno from '../../../img/partnership/proecuador.png'
import dos from '../../../img/partnership/agrocalidad.png'
import tres from '../../../img/partnership/logo-usfq.jpg'

class certifications extends Component {
  render() {
    return (
      <div className="certifications">     
      <h1>Partnership</h1><br/>  
        <div className="partner-container">
          <div>
            <img src={tres} alt=""/><br/>
            <a href="http://www.usfq.edu.ec/programas_academicos/business_school/Paginas/home.aspx" target="_blank" rel="noopener noreferrer">
            <button>Visitar sitio</button>
            </a>
          </div>
          <div>
            <img src={uno} alt=""/><br/>
            <a href="https://www.proecuador.gob.ec/" target="_blank" rel="noopener noreferrer">
            <button>Visitar sitio</button>
            </a>
          </div>
          <div>
             <img src={dos} alt=""/><br/>
             <a href="http://www.agrocalidad.gob.ec/" target="_blank" rel="noopener noreferrer">
               <button>Visitar sitio</button>
               </a>
          </div>
        </div>
      </div>
    );
  }
}

export default certifications;



// WEBPACK FOOTER //
// ./src/components/reusables/certifications/index.js